export default class Forms {
  constructor() {
    this.setupForms();
  }

  setupForms() {
    $(".form-formItem textarea").focus((e) => {
      $(e.currentTarget).val("");
    });

    $(".form-formItem textarea").blur((e) => {
      if ($(e.currentTarget).val() === "") {
        $(e.currentTarget).val(`*${$(e.currentTarget).data("default")}`);
      }
    });

    $('.form-formItem input[type="text"],.form-formItem select').focus((e) => {
      if (!$(e.currentTarget).parent().hasClass("form-ignoreAni")) {
        $(e.currentTarget).parent().addClass("is-focused");
      }
    });

    $('.form-formItem input[type="text"],.form-formItem select').blur((e) => {
      let valid = true;
      if ($(e.currentTarget).val() !== "") {
        // start validating form types
        if ($(e.currentTarget).parent().hasClass("form-formEmail")) {
          valid = this.validateEmail($(e.currentTarget).val());
        }

        // end validating form types

        if (!valid) {
          if (!$(e.currentTarget).parent().hasClass("form-ignoreAni")) {
            $(e.currentTarget).parent().addClass("has-error");
          }
        } else {
          if (!$(e.currentTarget).parent().hasClass("form-ignoreAni")) {
            $(e.currentTarget).parent().addClass("has-content");
          }
          $(e.currentTarget).parent().removeClass("has-error");
        }
      } else {
        $(e.currentTarget).parent().removeClass("has-content");
        $(e.currentTarget).parent().removeClass("has-error");
      }

      if (!$(e.currentTarget).parent().hasClass("form-ignoreAni")) {
        $(e.currentTarget).parent().removeClass("is-focused");
      }
    });
  }

  validateEmail(email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
}



// WEBPACK FOOTER //
// ./js/controllers/modules/Forms.js